import { render } from "./SimpleSubjectInput.vue?vue&type=template&id=2b56ca22"
import script from "./SimpleSubjectInput.vue?vue&type=script&lang=js"
export * from "./SimpleSubjectInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__